class LibraryController {
  static $inject = ['$state'];

  constructor($state) {
    this.$state = $state;
    this.name = 'library';

    this.breadcrumbsItems = [{
        label: 'Job Monitor'
      }, {
        label: 'Tremendous Technologies',
        isCurrent: true,
    }];

    this.dashboardBreadcrumbs = [{
        label: 'Dashboard',
        isCurrent: true,
    }];

    this.sidebarNavItems = [{
        icon: 'notification',
        label: 'My View'
      }, {
        icon: 'monetization_on',
        label: 'My Pay'
      }, {
        icon: 'watch_later',
        label: 'My Time'
      }, {
        icon: 'people',
        label: 'My Team'
      }, {
        icon: 'description',
        label: 'Forms'
      }, {
        icon: 'insert_drive_file',
        label: 'Documents'
      }, {
        icon: 'settings',
        label: 'Admin'
    }];

    this.homeBreadCrumbs = [{
        label: 'My View'
    }];

    this.listItemHeading = 'Notifications';

    this.notificationsData =  [
    {
      title: 'Singapore',
      hasErrors: false,
      date: 1510704000,
      hour: -2211690600,
      id: 0,
      count: 4
    },
    
    {
      title: 'Japan',
      hasErrors: true,
      date: 1510704000,
      hour: -2211690600,
      id: 1,
      count: 8
    },
    {
      title: 'UK',
      hasErrors: false,
      date: 1510704000,
      hour: -2211690600,
      id: 2,
      count: 7
    },
    {
      title: 'Egypt',
      hasErrors: false,
      date: 1510704000,
      hour: -2211690600,
      id: 3,
      count: 4
    }];

    this.masterDataTabs = [{
      id: 'tab-1',
      tabLabel: 'Tab 1',    
    },{
      id: 'tab-2',
      tabLabel: 'Long tab item 2',
    },{
      id: 'tab-3',
      tabLabel: 'Long tab 3',
    }, 
    {
      id: 'tab-4',
      tabLabel: 'Tab 4',
    }];    

    this.mainNavItems = [{
      label: 'Dashboard'
    }, {
      label: 'Executive Summary'
    }, {
      label: 'Training'
    }, {
      label: 'Help'
    }];

    this.userProfileItems = [{
      label: 'Settings'
    }, {
      label: 'Log out'
    }];

    this.timelineContextualMenuItems = [{
      id: '1',
      type: 'checkbox',
      icon: 'pay-date',
      color: 'green',
      label: 'Pay Dates'
    }, {
      id: '2',
      type: 'checkbox',
      icon: 'cut-off-date',
      color: 'purple',
      label: 'Cut-off Days'
    }, {
      id: '3',
      type: 'checkbox',
      icon: 'success',
      label: 'Successful Sync Points'
    }, {
      id: '4',
      type: 'checkbox',
      icon: 'error',
      label: 'Failed Sync Points'
    }, {
      id: '5',
      type: 'checkbox',
      icon: 'circle',
      label: 'Upcoming Sync Points'
    }, {
      id: '6',
      type: 'checkbox',
      icon: 'menu-icon locked-period',
      label: 'Locked period'
    }];
      
    this.dataCompositionLegend = [{
      color: '7c959f',
      label: 'Enhanced',
      percentage: '110',
      count: '236',
    }, {
      color: '53727f',
      label: 'G2',
      percentage: '10.5',
      count: '414',
    }, {
      color: '2e4f60',
      label: 'SSL',
      percentage: '17.5',
      count: '543',
    }];

    this.dropdownTabs = [{
      title: 'Country',
      content: [{name: 'Egypt', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: true},
                {name: 'Finland', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'Hungary', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'Jamaica', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'Japan', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'Luxemburg', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'New Zealand', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'Poland', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'United Arab Emirates', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'United Kingdom', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'Sweden', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false},
                {name: 'Urugai', value: '../assets/img/flag.png', isSelected: false, isDefaultSelected: false}],
      selectedValue: 'Egypt',
      open: false,
      
    }, {
      title: 'Company',
      content: [{name: 'Bombastic Beverage Co.', value: ''},
                {name: 'Devlish Designs', value: ''},
                {name: 'Fantastic Fashion', value: ''}],
      selectedValue: 'Devlish Designs',
      open: false,
    }, {
      title: 'Paygroup',
      content: [{name: 'Executives', value: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad illum in delectus modi laboriosam.'},
                {name: 'Part-time Employees', value: ' Itaque ipsam cum nobis sunt laborum, aspernatur velit enim porro facilis eligendi.'},
                {name: 'Regular Employees', value: ', odit consequatur laudantium repudiandae'}],
      selectedValue: 'Regular Employees',
      open: false,
    }];


     this.allErrorsDropdown = [{
      label: 'All Errors',
      icon: ''
    }, {
      label: 'Payroll Blockers',
      icon: 'flag'
    }, {
      label: 'Confirguration',
      icon: ''
    }, {
      label: 'Data',
      icon: ''
    }, {
      label: 'Informational',
      icon: ''
    }, {
      label: 'Process',
      icon: ''
    }];

    this.cycles = [{
          title: 27,
          disabled: true,
          pin: 'purple',
          month: 'Oct'
      }, {
          title: 28,
          disabled: true,
          month: 'Oct'
      }, {
          title: 29,
          disabled: true,
          month: 'Oct'
      }, {
          title: 30,
          disabled: true,
          month: 'Oct'
      }, {
          title: 31,
          disabled: true,
          month: 'Oct'
      }, {
          title: 1,
          disabled: false,
          status: 'success',
          start: true,
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }, {
          title: 2,
          disabled: false,
          current: true,
          month: 'Nov'
      }, {
          title: 3,
          disabled: false,
          status: 'error',
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }, {
          title: 4,
          disabled: false,
          month: 'Nov'
      }, {
          title: 5,
          disabled: false,
          month: 'Nov'
      }, {
          title: 6,
          disabled: false,
          month: 'Nov'
      }, {
          title: 7,
          disabled: false,
          month: 'Nov'
      }, {
          title: 8,
          disabled: false,
          month: 'Nov'
      }, {
          title: 9,
          disabled: false,
          month: 'Nov'
      }, {
          title: 10,
          disabled: false,
          status: 'error',
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }, {
          title: 11,
          disabled: false,
          today: true,
          month: 'Nov'
      }, {
          title: 12,
          disabled: false,
          month: 'Nov'
      }, {
          title: 13,
          disabled: false,
          month: 'Nov'
      }, {
          title: 14,
          disabled: false,
          month: 'Nov'
      }, {
          title: 15,
          disabled: false,
          month: 'Nov'
      }, {
          title: 16,
          disabled: false,
          month: 'Nov'
      }, {
          title: 17,
          disabled: false,
          icon: 'circle',
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }, {
          title: 18,
          disabled: false,
          month: 'Nov'
      }, {
          title: 19,
          disabled: false,
          month: 'Nov'
      }, {
          title: 20,
          disabled: false,
          month: 'Nov'
      }, {
          title: 21,
          disabled: false,
          month: 'Nov'
      }, {
          title: 22,
          disabled: false,
          month: 'Nov'
      }, {
          title: 23,
          disabled: false,
          month: 'Nov'
      }, {
          title: 24,
          disabled: false,
          icon: 'circle',
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }, {
          title: 25,
          disabled: false,
          pin: 'purple',
          description: 'Lorem ipsum dolor sin',
          cycleStart: true,
          month: 'Nov'
      }, {
          title: 26,
          disabled: false,
          month: 'Nov'
      }, {
          title: 27,
          disabled: false,
          month: 'Nov'
      }, {
          title: 28,
          disabled: false,
          pin: 'green',
          cycleEnd: true,
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }, {
          title: 29,
          disabled: false,
          icon: 'circle',
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }, {
          title: 30,
          disabled: false,
          icon: 'circle',
          end: true,
          description: 'Lorem ipsum dolor sin',
          month: 'Nov'
      }];

      this.uploadedFile = false;

      this.cycles = [{
            title: 27,
            disabled: true,
            pin: 'purple',
            month: 'Oct'
        }, {
            title: 28,
            disabled: true,
            month: 'Oct'
        }, {
            title: 29,
            disabled: true,
            month: 'Oct'
        }, {
            title: 30,
            disabled: true,
            month: 'Oct'
        }, {
            title: 31,
            disabled: true,
            month: 'Oct'
        }, {
            title: 1,
            disabled: false,
            status: 'success',
            start: true,
            description: 'Lorem ipsum dolor sin',
            month: 'Nov'
        }, {
            title: 2,
            disabled: false,
            current: true,
            month: 'Nov'
        }, {
            title: 3,
            disabled: false,
            status: 'error',
            description: 'Lorem ipsum dolor sin',
            month: 'Nov'
        }, {
            title: 4,
            disabled: false,
            month: 'Nov'
        }, {
            title: 5,
            disabled: false,
            month: 'Nov'
        }, {
            title: 6,
            disabled: false,
            month: 'Nov'
        }, {
            title: 7,
            disabled: false,
            month: 'Nov'
        }, {
            title: 8,
            disabled: false,
            month: 'Nov'
        }, {
            title: 9,
            disabled: false,
            month: 'Nov'
        }, {
            title: 10,
            disabled: false,
            status: 'error',
            description: 'Lorem ipsum dolor sin',
            month: 'Nov'
        }, {
            title: 11,
            disabled: false,
            today: true,
            month: 'Nov'
        }, {
            title: 12,
            disabled: false,
            month: 'Nov'
        }, {
            title: 13,
            disabled: false,
            month: 'Nov'
        }, {
            title: 14,
            disabled: false,
            month: 'Nov'
        }, {
            title: 15,
            disabled: false,
            month: 'Nov'
        }, {
            title: 16,
            disabled: false,
            month: 'Nov'
        }, {
            title: 17,
            disabled: false,
            icon: 'circle',
            description: 'Lorem ipsum dolor sin',
            month: 'Nov'
        }, {
            title: 18,
            disabled: false,
            month: 'Nov'
        }, {
            title: 19,
            disabled: false,
            month: 'Nov'
        }, {
            title: 20,
            disabled: false,
            month: 'Nov'
        }, {
            title: 21,
            disabled: false,
            month: 'Nov'
        }, {
            title: 22,
            disabled: false,
            month: 'Nov'
        }, {
            title: 23,
            disabled: false,
            month: 'Nov'
        }, {
            title: 24,
            disabled: false,
            icon: 'circle',
            description: 'Lorem ipsum dolor sin',
            month: 'Nov'
        }, {
            title: 25,
            disabled: false,
            pin: 'purple',
            description: 'Lorem ipsum dolor sin',
            cycleStart: true,
            month: 'Nov'
        }, {
            title: 26,
            disabled: false,
            month: 'Nov'
        }, {
            title: 27,
            disabled: false,
            month: 'Nov'
        }, {
            title: 28,
            disabled: false,
            pin: 'green',
            cycleEnd: true,
            description: 'Lorem ipsum dolor sin',
            month: 'Nov'
        }, {
            title: 29,
            disabled: false,
            icon: 'circle',
            description: 'Lorem ipsum dolor sin',
            month: 'Nov'
        }, {
            title: 30,
            disabled: false,
            icon: 'circle',
            end: true,  
            description: 'Lorem ipsum dolor sin',
            month: 'Nov'
        }];

        this.userAuthorizations = {
          tableHead: {
            row: [{
              fieldContent: 'Name',  
            }, {
              fieldContent: 'Global View Employee ID',
            }, {
              fieldContent: 'Paygroup Access',
            }, {
              fieldContent: 'Access Type',
            }],
          },
          tableBody: [{
            row: [{
              fieldContent: 'Carl Garza',  
            }, {
              fieldContent: '79033',
            }, {
              fieldContent: 'All paygroups',
            }, {
              fieldContent: 'Read & Write',
            }],
          }, {
            row: [{
              fieldContent: 'Katherine Nguyen',  
            }, {
              fieldContent: '5009',
            }, {
              fieldContent: 'Executives, Regular Employees',
            }, {
              fieldContent: 'Read',
            }],
          }, {
            row: [{
              fieldContent: 'Ophelia Evans',  
            }, {
              fieldContent: '6288',
            }, {
              fieldContent: 'Consultants, Regular Employees',
            }, {
              fieldContent: 'Read',
            }],
          }, {
            row: [{
              fieldContent: 'Sean Lawrence',  
            }, {
              fieldContent: '92408',
            }, {
              fieldContent: 'Regular Employees',
            }, {
              fieldContent: 'Write',
            }],
          }, {
            row: [{
              fieldContent: 'Teresa Nichols',  
            }, {
              fieldContent: '26105',
            }, {
              fieldContent: 'Executives, Consultants, Regular Employees',
            }, {
              fieldContent: 'Read & Write',
            }],
          }, {
            row: [{
              fieldContent: 'Fannie Schmidt',  
            }, {
              fieldContent: '79033',
            }, {
              fieldContent: 'Regular Employees',
            }, {
              fieldContent: 'Write',
            }],
          }, {
            row: [{
              fieldContent: 'Alejandro Benson',  
            }, {
              fieldContent: '57569',
            }, {
              fieldContent: 'All paygroups',
            }, {
              fieldContent: 'Write',
            }],
          },]
        };
        
        this.sideModalOpen = false;
        this.modalOpen = false;
        this.dropdownItemSelected = false;

        this.modal = {
          title: "Upload file",
          subtitle: "You can batch correct several errors by uploading one or more files"
        }

        this.countriesTypeaheadOptions = {
          maxItems: 10,
          valueField: 'code',
          labelField: 'name',
          searchField: ['code', 'name'],
          options: [{
            name: "United States", code: "US"
          },{
            name: "United Kingdom", code: "UK"
          }, {
            name: "Bulgaria", code: "BG"
          }]
        };
    }

    openTooltip() {
      this.tooltipOpen = !this.tooltipOpen;
    }
    
    closeToast() {
      this.isHidden = true;
    }

    uploadFiles() {
      this.uploadedFilesNumber = true;
    }

    toggleSideModal(event) {
      this.sideModalOpen = !this.sideModalOpen
    }

    openModal(event) {
      this.modalOpen = !this.modalOpen;
    }

    selectDropdownItem (e, item) {
      event.preventDefault();
      event.stopPropagation();

      this.item = item;
      let index = undefined;

      switch(this.item.title) {
        case "Country":
          index = 0;
          break;
        case "Company":
          index = 1;
          break;
        case "Paygroup":
          index = 3;
          break;
        default:
          index = 0;
      }

      this.liIsSelected = this.item.isSelected;

      if (this.liIsSelected) {
        this.dropdownTabs[index].content.forEach(li => li.isSelected = false);

      } else {
        this.dropdownTabs[index].content.forEach(li => li.isSelected = false);
        this.liIsSelected = !this.liIsSelected;
      }
      
      this.item.isSelected = this.liIsSelected;
    }
}

export default LibraryController;



// WEBPACK FOOTER //
// ./src/app/pages/library/library.controller.js